import { render, staticRenderFns } from "./ViewEnrollment.vue?vue&type=template&id=68596e42&scoped=true&"
import script from "./ViewEnrollment.vue?vue&type=script&lang=js&"
export * from "./ViewEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./ViewEnrollment.vue?vue&type=style&index=0&id=68596e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68596e42",
  null
  
)

export default component.exports